import {NgModule} from '@angular/core';
import {EntityDataService, EntityServices} from "@ngrx/data";
import {InsolesProviderModelRepository} from "./impl/service/ngrx/insolesProviderModel.repository";
import {InsolesProviderModelDataService} from "./impl/service/ngrx/insolesProviderModelData.service";
import {errorMessages} from "../../../core/error/errorMessages";
@NgModule()
export class InsolesProviderModelModule {
     constructor(entityDataService: EntityDataService,
                 entityServices: EntityServices,
                 repository: InsolesProviderModelRepository,
                 dataService: InsolesProviderModelDataService,
    ) {

        entityDataService.registerServices({
            InsolesProviderModel: dataService,
        });

        entityServices.registerEntityCollectionServices({
            InsolesProviderModel: repository,
        });

         errorMessages.set('INSOLE_MODEL_PROVIDER_SAVE_CAM_MACHINE_WRONG_METHOD', 'Mauvaise méthode');
        errorMessages.set('INSOLE_MODEL_PROVIDER_SAVE_CAM_MACHINE_CAM_MACHINE_ALREADY_USED', 'La machine est déjà utilisée pour ce modèle');
    }
}
